import axios from 'axios';

const deviceIdKey = 'mycommunity-device-id';
const deviceId = () => {
  let value = localStorage.getItem(deviceIdKey);
  if (!value) {
    value = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(deviceIdKey, value);
  }
  return value;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: {
    // Do not set a default Content-Type here
    'Accept': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    config.headers['X-Device-Id'] = deviceId();
    const token = localStorage.getItem('token');
    if (token) {
      if (typeof token !== 'string' || token.split('.').length !== 3) {
        localStorage.clear();
        throw new Error('Invalid token');
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const publicAuthRequest = ['/api/auth/login', '/api/auth/forgot-password', '/api/auth/reset-password']
      .some(path => requestUrl.includes(path));
    if (error.response?.status === 401 && !publicAuthRequest) {
      localStorage.clear();
      window.location.href = '/login';
    }
    if (error.response?.status === 403 &&
        error.response?.headers?.['x-community-access-blocked'] === 'true') {
      const message = error.response?.data?.message ||
        'Your community is not active. Please contact your Community Administrator or MyCommunity support.';
      sessionStorage.setItem('loginMessage', message);
      ['token','role','username','userId','communityId','communityName','communityDisplayName']
        .forEach(key => localStorage.removeItem(key));
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
